export enum AccountType {
	FIX = 'FIX',
	MOBILE = 'MOBILE',
	INTERNET = 'INTERNET',
	WFBB = 'WFBB',
	AAMALI = 'AAMALI'
}
